<template>
  <div ref="intersectionContainer">
    <el-table
      class="m-t-10"
      height="720"
      :data="data"
      v-loading="loading"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="content" label="Текст сообщения" />
      <el-table-column v-if="status === '1'" prop="comment" label="Причина" width="300" />

      <el-table-column label="Создано" width="100" align="center">
        <template #default="{ row }">
          {{ parseDate(row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column v-if="status === '1'" label="Проверено" width="100" align="center">
        <template #default="{ row }">
          {{ parseDate(row.moderatedDate) }}
        </template>
      </el-table-column>
      <template #append>
        <div ref="observerTrigger"></div>
      </template>
    </el-table>
  </div>
</template>

<script>
import { parseDate } from "@/plugins/dateParser";
import { mapGetters } from "vuex";

export default {
  props: ["status"],
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pageSize: 10,
      observer: undefined,
    };
  },
  computed: {
    ...mapGetters(["getTelegramLink"]),
  },
  methods: {
    tableRowClassName(e) {
      if (e.row.isUnread) {
        return "new-request";
      } else if (e.row.hasUnreadComments) {
        return "new-comment";
      } else {
        return "";
      }
    },
    parseDate(d) {
      return parseDate(d);
    },

    async fetchData() {
      try {
        this.loading = true;
        const result = await this.$store.dispatch("fetchModerateMessages", {
          skip: (this.page - 1) * this.pageSize,
          take: this.pageSize,
          status: this.status,
        });
        if (result) {
          this.data = result;
          if (result.length === this.pageSize) {
            this.createObserver();
          }
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchNextData() {
      try {
        this.page++;
        const result = await this.$store.dispatch("fetchModerateMessages", {
          skip: (this.page - 1) * this.pageSize,
          take: this.pageSize,
          status: this.status,
        });
        if (result) {
          this.data = [...this.data, ...result];
          if (result.length === this.pageSize || result.length === 0) {
            this.unobserveIntersecting();
          }
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
    },

    createObserver() {
      const callback = (e) => {
        if (e[0].isIntersecting) {
          this.fetchNextData();
        }
      };
      const options = {
        root: this.$refs.intersectionContainer,
        rootMargin: "0px",
        threshold: 0,
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.observerTrigger);
    },
    unobserveIntersecting() {
      if (this.$refs.observerTrigger) {
        this.observer.unobserve(this.$refs.observerTrigger);
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
::v-deep .el-table .new-comment {
  background: #fdf6ec;
}
::v-deep .el-table .new-request {
  background: #d9ecff;
}
</style>
